export const PAGE_JOB_LIST_DISPLAYED = 'job_list_displayed';
export const PAGE_JOB_UPGRADE_BUTTON_VIEWED = 'job_upgrade_button_viewed';
export const EVENT_NAME_JOB_ACTION_MENU_PRESSED = 'job_action_menu_pressed';
export const EVENT_NAME_JOB_UPGRADED_BUTTON_PRESSED =
  'job_upgrade_button_pressed';
